import {ComponentId} from "./component_id";


export interface PageLeftItem {
    type: string;
    data?: string;
    dataObj?: any;
    title?: string;
}

export const LEFT_ITEM_UNDEFINED: PageLeftItem = { type: ""};

export interface Page {

    // the title of the page
    title: string;

    // the optional subtitle of the page
    subtitle?: string;

    two_columns: boolean;

    // the color of the menu on desktop and mobile (dark | light)
    desktop_navbar_color?: string;
    mobile_navbar_color?: string;

    // if we have to show some placeholder content on the right
    image?: string;
    video?: string;

    // The menu with the anchors of the components of the page
    internal_menu?: string[];

    // for each item the be displayed on the left,
    // we have its id and some optional parameters to customize it
    left_column?: PageLeftItem[];

    // for each component, we have its id, the url it will use to load its contents
    // and some optional parameters to customize it
    components: ComponentId[];

    path?: string | {alias: string};

    langcode?: string;
}